'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M22 11v2H9V7h9c2.21 0 4 1.79 4 4zM2 14v2h6v2h8v-2h6v-2H2zm5.14-1.9c1.16-1.19 1.14-3.08-.04-4.24-1.19-1.16-3.08-1.14-4.24.04-1.16 1.19-1.14 3.08.04 4.24 1.19 1.16 3.08 1.14 4.24-.04z' });

var AirlineSeatFlat = function AirlineSeatFlat(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

AirlineSeatFlat = (0, _pure2.default)(AirlineSeatFlat);
AirlineSeatFlat.muiName = 'SvgIcon';

exports.default = AirlineSeatFlat;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/AirlineSeatFlat.js
// module id = 2100
// module chunks = 0